import React, { useContext } from 'react'

import { useLocation } from "react-router-dom"

import ResponsiveButton from '../ResponsiveButton'
import TableIcon from '@mui/icons-material/TableChart';

import { ScreenContext } from '..';
import ClientsTable from './ClientsTable';
import NotificationTable from './NotificationTable';
import CampaignTable from './CampaignTable';
import EnterpriseTable from "./EnterpriseTable"
import TemplateGrid from '../../Templates/360dialog'


const TabTables = ({ loadMoreGroups }) => {

    const location = useLocation()

    const { selectedTab, getClients } = useContext(ScreenContext)
    
    const subTab = (new URLSearchParams(location.search)).get("subTab")
    const selectedTabParam = (new URLSearchParams(location.search)).get("selectedTab")

    if (selectedTab === "clients")
        return <ClientsTable loadMoreGroups={loadMoreGroups} />
    
    if (selectedTab === "campaigns") {
        if (subTab === "templates")
            return <TemplateGrid />
        if (selectedTabParam === "notifications")
            return <NotificationTable />
        return <CampaignTable />
    }
    
    if (selectedTab === "enterprises")
        return <EnterpriseTable getClients={getClients} loadMoreGroups={loadMoreGroups}/>

    return <></>
}

export default TabTables
